<template>
  <div class="banner-box-mobile w-100 pb-5 position-relative" :class="color">
    <div class="banner-box-mobile__image-container">
      <v-img :src="`${publicPath}${image}`" width="auto" max-height="373" aspect-ratio="1" cover />
      <span class="banner-box-mobile__title-container">
        <h2
          class="banner-box-mobile__title"
          :class="{
            'sz-red--text': styleVariant === 'primary',
            'ap-blue--text': styleVariant === 'secondary'
          }"
          v-html="title"
          v-orphans
      /></span>
    </div>
    <div class="sz-primary-grey--text px-3 py-4" v-html="text" />
    <div v-if="link?.href" class="text-center py-5">
      <BaseButton
        :variant="styleVariant === 'secondary' ? 'ap' : 'primary'"
        :href="link?.href"
        arrow
      >
        {{ link?.text_mobile ?? link.text }}
      </BaseButton>
    </div>
  </div>
</template>
<script setup>
import BaseButton from '@/components/widgets/BaseButton.vue'

defineProps({
  publicPath: {
    type: String,
    default: ''
  },
  title: {
    required: true,
    type: String
  },
  text: {
    required: true,
    type: String
  },
  link: {
    type: Object,
    default: () => {
      return { href: '#', text: null }
    }
  },
  image: {
    type: [String, Object]
  },
  // 'primary' or 'secondary' - change to enum after migrating to ts
  styleVariant: {
    type: String,
    default: 'primary'
  },
  color: {
    type: String,
    default: 'sz-primary-background'
  }
})
</script>
<style lang="scss">
.banner-box-mobile {
  &__image-container {
    position: relative;
  }

  &__title-container {
    position: absolute;
    bottom: 20px;
    text-align: center;
    margin: 0 30px;
    left: 0;
    right: 0;
  }

  &__title {
    background-color: white;
    padding: 10px 20px;
    font-weight: bold;
  }
}
</style>
